import React from 'react'
import { settings } from '../../resources'
import styled from 'react-emotion'

const formatCurrency = value => {
  if ((value >= 0 && value < 1000) || (value < 0 && value > -1000))
    return value

  const reverse = value => value.toString().split('').reverse().join('')
  const formatted = reverse(value).replace(/(\d{3})/g, '$1' + settings.thousandDelimiter)
  return reverse(formatted)
}

const NoBreak = styled('span')`
  white-space: nowrap;
`

export default ({ value, hideZero }) => {
  const isNumber = /^[\d|-]+$/g.test(value)

  if (hideZero && value === 0)
    return null

  return (
    <NoBreak className="localized-currency">
      {isNumber ? formatCurrency(value) + settings.currencySymbol : value}
    </NoBreak>
  )
}
